import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import { JobFileCard } from '../Files';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  }
});


const JobFileCards = ({ classes, files, handleEdit }) => {
  return(
    <div className={classes.root}>
      {files &&
        files.map((file, i) => {
          return <JobFileCard key={i} file={file} handleEdit={handleEdit}/>;
        })
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const id = props.project.id;
  return ({
    files: state.filesState.filter ( file => {
      return (file.projectId === id && file.category === "file");
    }),
  });
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(JobFileCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Files/JobFileCards.jsx